import React from 'react'
import { Link as RouterLink, useRouteMatch } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import ContactlessOutlinedIcon from 'components/material-symbol/icons/Contactless'
import CreditCardOutlinedIcon from 'components/material-symbol/icons/CreditCard'
import ChevronRightIcon from 'components/material-symbol/icons/ChevronRight'
import { withProtectedRoute, roles, useAuth } from 'lib/auth'
import { PageHeader } from 'components/page-header'
import usePaymentsStyles from './styles'

const PaymentNavLink = ({ to, icon: Icon, title, caption, classes }) => (
  <Link
    component={RouterLink}
    to={to}
    underline="none"
    className={classes.navCard}
  >
    <Box className={classes.navIconWrap}>
      <Icon className={classes.navIcon} />
    </Box>
    <Box className={classes.navCopy}>
      <Typography className={classes.navTitle}>{title}</Typography>
      <Typography className={classes.navCaption}>{caption}</Typography>
    </Box>
    <ChevronRightIcon className={classes.navChevron} />
  </Link>
)

const CoachMenuOptions = ({ path, classes }) => (
  <>
    <PaymentNavLink
      to={`${path}/payment-accounts`}
      icon={ContactlessOutlinedIcon}
      title="Manage online payment accounts"
      caption="Connect Stripe, PayPal, and other payment providers."
      classes={classes}
    />
    <PaymentNavLink
      to={`${path}/transactions`}
      icon={CreditCardOutlinedIcon}
      title="Manage transactions"
      caption="View income, refunds, and export transaction history."
      classes={classes}
    />
  </>
)

const ConsumerMenuOptions = ({ path, classes }) => (
  <PaymentNavLink
    to={`${path}/transactions`}
    icon={CreditCardOutlinedIcon}
    title="Manage transactions"
    caption="View transactions associated with your purchases."
    classes={classes}
  />
)

const PaymentsPage = () => {
  const classes = usePaymentsStyles()
  const { isCoach } = useAuth()
  const { path } = useRouteMatch()

  return (
    <>
      <PageHeader title="Payments" />
      <Box className={classes.contentContainer}>
        <Box className={classes.stack}>
          {isCoach ? (
            <CoachMenuOptions path={path} classes={classes} />
          ) : (
            <ConsumerMenuOptions path={path} classes={classes} />
          )}
        </Box>
      </Box>
    </>
  )
}

export default withProtectedRoute(PaymentsPage, [roles.COACH, roles.CONSUMER])
